'use strict'; // Geometry only: orientation changes must never reopen or replace a pack session.

function canvasSize(width, height, landscape) {
  if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) return null;
  const available = Math.max(120, landscape ? height - 104 : height * .61);
  const scale = Math.min(width / 480, available / 610, 1);
  return {
    width: Math.round(480 * scale),
    height: Math.round(610 * scale)
  };
}

function bindMobileLayout(host, root, stage, canvas) {
  var _host$visualViewport;

  let disposed = false,
      frame = 0,
      last = '';

  function sync() {
    frame = 0;
    if (disposed) return;
    const v = host.visualViewport; // Pinch zoom remains browser-controlled, instead of shrinking the card twice.

    const height = v && (!v.scale || Math.abs(v.scale - 1) < .02) ? v.height : host.innerHeight;
    const width = root.clientWidth,
          landscape = width >= 520 && width > height;
    root.style.setProperty('--opcards-view-height', height + 'px');
    const size = canvasSize(stage.clientWidth, height, landscape);
    if (!size) return;
    const signature = size.width + 'x' + size.height;

    if (signature !== last) {
      last = signature;
      canvas.style.width = size.width + 'px';
      canvas.style.height = size.height + 'px';
      stage.style.height = size.height + 'px';
    }
  }

  function schedule() {
    if (!disposed && !frame) frame = host.requestAnimationFrame(sync);
  }

  host.addEventListener('resize', sync);
  host.addEventListener('orientationchange', sync);
  (_host$visualViewport = host.visualViewport) === null || _host$visualViewport === void 0 ? void 0 : _host$visualViewport.addEventListener('resize', sync);
  const observer = typeof host.ResizeObserver === 'function' ? new host.ResizeObserver(schedule) : null;
  observer === null || observer === void 0 ? void 0 : observer.observe(stage);
  sync();
  return () => {
    var _host$visualViewport2;

    disposed = true;
    if (frame) host.cancelAnimationFrame(frame);
    observer === null || observer === void 0 ? void 0 : observer.disconnect();
    host.removeEventListener('resize', sync);
    host.removeEventListener('orientationchange', sync);
    (_host$visualViewport2 = host.visualViewport) === null || _host$visualViewport2 === void 0 ? void 0 : _host$visualViewport2.removeEventListener('resize', sync);
  };
}

module.exports = {
  canvasSize,
  bindMobileLayout
};
